import React from 'react';
import "./projects.css";
import { NavLink } from 'react-router-dom';
import Pro1 from "../images/deBooking.PNG";
import Pro2 from "../images/academia.PNG";
import Pro3 from "../images/top-player.PNG";


const ProjectsComponent = () => {
  return (
    <div>
        <div className="container">
        <h1 className="project-heading">My Projects</h1>
        <div className="project-container">
          <div className="project-card">
            <img src={Pro1} alt="image" />
            <h4 className="project-title">Hotel Reservation App Design</h4>
            <div className="project-details">
              <p>This is user interface of a hotel booking website. I use React.js, javaScript, HTMl5 and CSS3 for developing this. <br />This work is not responsive</p>
              <div className="project-btns">
                <NavLink to="" className="btn">Live Site</NavLink>
                <NavLink to="" className="btn">Source Code</NavLink>
              </div>
            </div>
          </div>
          <div className="project-card">
            <img src={Pro2} alt="image" />
            <h4 className="project-title">Educational Website Design</h4>
            <div className="project-details">
              <p>This is user interface of a Online Education website. I use React.js, javaScript, HTMl5 and CSS3 for developing this. <br />This work is not responsive</p>
              <div className="project-btns">
                <NavLink to="url.com" className="btn">Live Site</NavLink>
                <NavLink to="url.com" className="btn">Source Code</NavLink>
              </div>
            </div>
          </div>
          <div className="project-card">
            <img src={Pro3} alt="image" />
            <h4 className="project-title">Top Player</h4>
            <div className="project-details">
              <p>This is user interface of a Player Ranking website. I use only HTMl5, CSS3 amd bootstrap for developing responsive page. <br />This work is fully responsibe</p>
              <div className="project-btns">
                <NavLink to="url.com" className="btn">Live Site</NavLink>
                <NavLink to="url.com" className="btn">Source Code</NavLink>
              </div>
            </div>
          </div>
          <div className="project-card">
            <img src={Pro3} alt="image" />
            <h4 className="project-title">Top Player</h4>
            <div className="project-details">
              <p>This is user interface of a Player Ranking website. I use only HTMl5, CSS3 amd bootstrap for developing responsive page. <br />This work is fully responsibe</p>
              <div className="project-btns">
                <NavLink to="url.com" className="btn">Live Site</NavLink>
                <NavLink to="url.com" className="btn">Source Code</NavLink>
              </div>
            </div>
          </div>
          <div className="project-card">
            <img src={Pro3} alt="image" />
            <h4 className="project-title">Top Player</h4>
            <div className="project-details">
              <p>This is user interface of a Player Ranking website. I use only HTMl5, CSS3 amd bootstrap for developing responsive page. <br />This work is fully responsibe</p>
              <div className="project-btns">
                <NavLink to="url.com" className="btn">Live Site</NavLink>
                <NavLink to="url.com" className="btn">Source Code</NavLink>
              </div>
            </div>
          </div>
          <div className="project-card">
            <img src={Pro3} alt="image" />
            <h4 className="project-title">Top Player</h4>
            <div className="project-details">
              <p>This is user interface of a Player Ranking website. I use only HTMl5, CSS3 amd bootstrap for developing responsive page. <br />This work is fully responsibe</p>
              <div className="project-btns">
                <NavLink to="url.com" className="btn">Live Site</NavLink>
                <NavLink to="url.com" className="btn">Source Code</NavLink>
              </div>
            </div>
          </div>
        </div>
        <div className="show-more">
          <button className='show-btn'>Show More</button>
        
        </div>
      </div>
    </div>
  )
}

export default ProjectsComponent;